import { makeStyles } from "@material-ui/core/styles";
import theme from "theme";

const useStyles = makeStyles({
  filter: {
    width: 250,
    paddingTop: 21,
    paddingBottom: 21,
  },
  locationFilter: {
    width: 250,
    paddingTop: 15,
    paddingBottom: 15,
    background: "#FFF",
    textAlign: "left",
  },
  menuItemRoot: {
    width: 400,
    FontFace: "Arial"
  },
  filterSelect: {
    borderRadius: 0,
    minWidth: 200,
    marginTop: 16,
    marginBottom: 8,
    marginRight: 16,
    height: 61,
    "& .MuiOutlinedInput-input": {
      padding: 8,
      fontSize: 16,
    },
    "& .MuiInput-formControl": {
      marginTop: 24,
      paddingTop: 4,
      marginBottom: 8,
      border: "1px solid #ccc",
    },
    "& .MuiInput-underline:before": {
      borderBottom: 0,
      "&:hover": {
        borderBottom: 0,
      },
    },
    "& .MuiSelect-icon": {
      marginRight: 8,
    },
    "& .MuiSelect-select": {
      paddingLeft: 16,
      marginBottom: 4,
    },
  },
  filterAutoCompleteLabel: {
    marginTop: 30,
    fontSize: "14px",
    color: "#2F2F2F",
  },
  filterAutoComplete: {
    background: "#FFFFFF",
    borderRadius: 0,
    width: 250,
    marginTop: 10,
    marginBottom: 30,
    marginRight: 16,
    "& .MuiOutlinedInput-input": {
      padding: 8,
    },
    "& .MuiAutocomplete-option": {
      color: "#707070",
    },
    "& .MuiInput-formControl": {
      // marginTop: 24,
      // paddingTop: 4,
      // marginBottom: 8,
      paddingLeft: 10,
      paddingTop: 3,
      paddingBottom: 3,
      fontSize: 16,
      color: "#707070",
      border: "1px solid #ccc",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "none !important",
      "&:hover": {
        borderBottom: 0,
      },
    },
  },
  confirmationDialogTitle: {
    paddingTop: '7px', 
    paddingBottom: '13px',
    paddingLeft: '64px',
    fontWeight: 600,
    fontSize: "22px !important",
  },
  signupTitle: {
    [theme.breakpoints.up('md')]: {
      fontSize: "40px",
      // padding: "16px",
      // marginLeft: "15px",
      fontWeight: 600,
    },
    [theme.breakpoints.down('sm')]: {
      fontWeight: 600,
      fontSize: "24px"
    }
  },
  signupDialog: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '74px',
      paddingBottom: '109px',
      paddingRight: '74px'
    },
    [theme.breakpoints.down('sm')]: {
      overflow: 'scroll',
      paddingBottom: '30px',
    }
  },
  confirmationDialogContent: {
    paddingLeft: "64px",
    paddingRight: "64px",
    fontSize: '18px'
  },
  signupContent: {
    padding: "14px",
    // margin: "30px"
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: "black",
  },
  thankyouTitle: {
    [theme.breakpoints.down('sm')]: {
      fontSize: "32px",
    },
    [theme.breakpoints.up('md')]: {
      fontSize: "40px",
    },
    paddingTop: "61px",
    paddingLeft: "74px",
    paddingRight: '74px',
    paddingBottom: '16px',
    fontWeight: 600,
    textAlign: "center",
  },
  thankyouContent: {
    paddingLeft: '74px',
    paddingRight: '74px',
    paddingBottom: '46px',
    fontSize: '21px',
  },
  thankyouActions: {
    paddingBottom: '68px'
  },
  redirectToHome: {
    marginBottom: "20px",
  },
  redirectToPublic: {
    marginTop: "-10px",
    marginBottom: "20px",
  },
  dialogContainer: {
    [theme.breakpoints.up('md')]: {
      maxHeight: "70vh",
      overflow: "hidden"
    },
    [theme.breakpoints.down('sm')]: {
      overflow: 'hidden'
    }
  },
  privacyLink: {
    color: "inherit",
    paddingLeft: "5px"
  },
  privacyLinkContainer: {
    display: "flex",
    flexDirection: "row",
    textAlign: "left",
    width: "100%",
    marginTop: "-0.9em"
  },
  registerButtons: {
    paddingTop: "0.6em"
  },
  return: {
    backgroundColor: "transparent",
    border: "1px solid black",
    fontSize: "1.2em",
  },
  privacyDialogContent: {
    padding: "5px 48px 74px 36px",
    font: "normal normal normal 16px/18px Arial",
    letterSpacing: "0.96px",
    color: "#343434",
    overflow: "scroll",
    maxHeight: "70vh"
  },
  privacyDialogTitle: {
    fontWeight: "bold",
    fontSize: "2em"
  },
  privacyHeader: {
    padding: "1.5em"
  },
  confirmationDialogActions: {
    paddingBottom: '30px'
  },
  link: {
    cursor: "pointer",
    color: '#2352D0'
  },
  passwordInfoContainer: {
    padding: 16,
  },
  passwordInfoList: {
    listStyleType: 'none',
    padding: 0,
  },
  validPassword: {
    color: theme.palette.vaildated.main,
  },
  invalidPassword: {
    color: "#f44336",
  },
  validTextField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: theme.palette.vaildated.main,
      },
      "&:hover fieldset": {
        borderColor: theme.palette.vaildated.main,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.vaildated.main,
      },
    },
    "& .MuiFormLabel-root": {
      color: theme.palette.vaildated.main,
    },
    "& .MuiFormLabel-root.Mui-focused": {
      color: theme.palette.vaildated.main,
    },
  },
}, { index: 999 });

export default useStyles;
